<template>
  <div class="header">
    <div class="top_content" v-if="!token">
      <el-cascader size="large" :options="options" v-model="selectedOptions" @change="handleChange"></el-cascader>
      <p>
        <span class="appCode">
          [ APP ]
          <span v-for="(v) in appCode" :key="v.id">
            {{v.mark}}
            <img class="ewmImg2" :src="picUrl + v.pic" />
          </span>
        </span>
        <span class="appletCode">
          [ 小程序 ]
          <img class="ewmImg" :src="picUrl + appletCode.pic" />
        </span>
        <span class="publicCode">
          [ 公众号 ]
          <img class="ewmImg" :src="picUrl + publicCode.pic" />
        </span>
        <span><router-link to="/login">[ 登录 ]</router-link></span>
        <span><router-link to="/login/register">[ 免费注册 ]</router-link></span>
        <a href="#" @click.prevent="goToPath">[ 关于我们]</a>
        <!-- <span><router-link to="/about/about" target="_blank">[ 关于我们]</router-link></span> -->
        <span><router-link to="/" target="_blank">[ 万知首页 ]</router-link></span>
      </p>
    </div>
    <div class="top_content" v-else>
      <el-cascader size="large" :options="options" v-model="selectedOptions" @change="handleChange"></el-cascader>
      <p>
        <span class="appCode">
          [ APP ]
          <span v-for="(v) in appCode" :key="v.id">
            {{v.mark}}
            <img class="ewmImg2" :src="picUrl + v.pic" />
          </span>
        </span>
        <span class="appletCode">
          [ 小程序 ]
          <img class="ewmImg" :src="picUrl + appletCode.pic" />
        </span>
        <span class="publicCode">
          [ 公众号 ]
          <img class="ewmImg" :src="picUrl + publicCode.pic" />
        </span>
        <span v-if="!(userInfo && userInfo.nickname)">亲 {{userInfo && userInfo.username}}，欢迎来到万知网！</span>
        <span v-else>亲 {{userInfo && userInfo.nickname}}，欢迎来到万知网！</span>
        <span><router-link to="/user">[ 个人中心 ]</router-link></span>
        <span @click="loingout()">[ 退出 ]</span>
        <span @click="indexPage()">[ 万知首页 ]</span>
      </p>
    </div>
  </div>
</template>
<script>
import sign from '@/auth/sign'
import $ from 'jquery'
import url from '@/axios/url'
import { getAppcode, getClientCity } from '@/axios/api'
import { getUserInfo } from "@/axios/userInfo"
import { provinceAndCityData, CodeToText, regionData, TextToCode } from 'element-china-area-data'
export default {
  data () {
    return {
      picUrl: url.picUrl,
      options: provinceAndCityData,
      selectedOptions: [],
      token: localStorage.getItem('token'),
      appid: 'wzwebapp',
      appcodeList: [],
      appCode: [],
      publicCode: {
        pic: ''
      },
      appletCode: {
        pic: ''
      },
      // userInfo: null
    }
  },
  computed: {
    userInfo: {
      get () {
        return JSON.parse(localStorage.getItem('userInfo'))
      },
      set () {}
    }
  },
  watch:{
    '$route.query':{
      immediate:true,
      handler(){
        if(this.$route.query.flag='100'){
          if( window.localStorage.getItem('isFlag') ==100){
            window.localStorage.removeItem('isFlag')
            this.$router.go();
          }
        }
      }
    }
  },
  created () {
    this.getAppcode()
    // if (localStorage.getItem('selectedOptionsCity')) {
    //   this.handleChange(localStorage.getItem('selectedOptionsCity').split(','))
    // } else {
    //   this.setAreaF()
    // }
    this.getClientCity()
    this.checkUserInfo()
  },
  methods: {
    goToPath(){
      this.$router.push('/about/about');
    },
    getLocation (a) { // address:  "中国 江苏 南京 电信"
      const that = this
      const address = a.split(' ')
      localStorage.setItem('getLocationCity', address[2]) // 默认地图定位
      const sheng = TextToCode[address[1] + '省']
      const shi = sheng[address[2] + '市']
      const point = [sheng.code, shi.code]
      console.log('point', point)
      if (point && point.length) {
        that.selectedOptions = localStorage.getItem('selectedOptionsCity') ? localStorage.getItem('selectedOptionsCity').split(',') : point
        this.handleChange(that.selectedOptions)
      } else {
        that.selectedOptions = localStorage.getItem('selectedOptionsCity') ? localStorage.getItem('selectedOptionsCity').split(',') : ['320000', '320900']
        this.setAreaF(that.selectedOptions)
      }
    },
    getAppcode () {
      this.id = localStorage.getItem('loveType')
      // 生成sign
      let oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000)
      }
      let signO = sign(oneParams)
      // 传递的参数
      oneParams.sign = signO
      getAppcode(oneParams).then(res => {
        if (res && res.data && res.data.code === 200) {
          const appcodeList = res.data.data || []
          const appCode = []
          appcodeList.forEach(e => {
            if (e.title === '公众号') {
              this.publicCode = e
            }
            if (e.title === '小程序') {
              this.appletCode = e
            }
            if (e.title === 'APP') {
              appCode.push(e)
            }
          })
          this.appCode = appCode
        }
      })
    },
    getClientCity () {
      let oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000)
      }
      let signO = sign(oneParams)
      // 传递的参数
      oneParams.sign = signO
      getClientCity(oneParams).then(res => {
        if (res && res.data && res.data.code === 200) {
          if (res.data.data.address) {
            this.getLocation(res.data.data.address)
          }else{
            this.getLocation('中国 江苏 南京')
          }
        }
      })
    },
    indexPage () {
      let routeUrl = this.$router.resolve({
        name: 'Index'
      })
      window.open(routeUrl.href, '_blank')
    },
    loingout () {
      let oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000)
      }
      let signO = sign(oneParams)
      oneParams.sign = signO
      $.ajax({
        url: `${url.wz}/public/v1/loginout`,
        type: 'post',
        data: oneParams,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        success: (res) => {
          if (res.code === 200) {
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
            if (this.$route.name === 'Index') {
              location.reload()
            } else {
              this.$router.push('/')
              location.reload()
              this.$store.dispatch('addVerification', 0)
            }
          } else {
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
            if (this.$route.name === 'Index') {
              location.reload()
            } else {
              this.$router.push('/')
              location.reload()
              this.$store.dispatch('addVerification', 0)
            }
          }
        },
        error: (err) => {
          console.log(err)
        }
      })
    },
    handleChange (arr) {
      this.setAreaF(arr)
      if (CodeToText[arr[1]] === '市辖区') {
        this.$store.commit('SET_AREA', CodeToText[arr[0]])
        this.$store.commit('SET_MAREA', CodeToText[arr[0]])
      } else {
        this.$store.commit('SET_AREA', CodeToText[arr[1]])
        this.$store.commit('SET_MAREA', CodeToText[arr[1]])
      }
    },
    setAreaF (arr = localStorage.getItem('selectedOptionsCity') ? localStorage.getItem('selectedOptionsCity').split(',') : ['320000', '320900']) {
      let leaveThree = []
      regionData.map((value, index) => {
        if (value.label === CodeToText[arr[0]]) {
          value.children.map((v, i) => {
            if (v.label === CodeToText[arr[1]]) {
              leaveThree = v.children
            }
          })
        }
      })
      // 20200627
      this.$store.dispatch('CUR_REGION', {
        curRegion: arr
      })
      // 20200627
      this.$store.commit('SET_LEAVETHREE', leaveThree)
      localStorage.setItem('selectedOptionsCity', arr)
    },
    checkUserInfo () {
      let oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000)
      }
      let signO = sign(oneParams)
      oneParams.sign = signO
      getUserInfo(oneParams).then(res => {
        if(res.data.code !== 200){
          localStorage.removeItem('userInfo')
          // this.userInfo = null
        } else {
          // this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        }
      }).catch(() => {
          localStorage.removeItem('userInfo')
          // this.userInfo = null
      })
    },
  }
}
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  line-height: 40px;
  background-color: #f0f2f5;
  height: 40px;
  font-size: 14px;
  color: #565656;
}
.top_content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top_content span {
  cursor: pointer;
}

.appletCode, .publicCode, .appCode {
  position: relative;
}
.appletCode .ewmImg, .publicCode .ewmImg {
  position: absolute;
  width: 120px;
  max-width: 120px;
  display: none;
  left: 0;
  top: 40px;
  border: 1px solid #ccc;
  z-index: 99;
}
.appCode  {
  position: relative;
  span {
    display: none;
    position: absolute;
    width: 120px;
    max-width: 1200px;
    left: 0;
    top: 40px;
    border: 1px solid #ccc;
    z-index: 99;
    text-align: center;
    background: #ccc;
    color: #000;
    .ewmImg2 {
      width: 120px;
      display: block;
    }
  }
  span:first-child {
    left: -120px
  }
}
.appletCode:hover {
   .ewmImg{
      display: block;
   }
}
.publicCode:hover {
  .ewmImg {
    display: block;
  }
}
.appCode:hover {
  span {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/HeaderArea.vue